export function showsBand(narrow: boolean, even: boolean, focused: boolean): boolean {
  return narrow && !even && !focused;
}
